import styled from "styled-components";
import pageAd1x from "../img/page-ads/page-ad-@1x.png";
import pageAd2x from "../img/page-ads/page-ad-@2x.png";

const StyledImage = styled.div`
  width: 384px;
  height: 49px;
  background-image: url(${pageAd1x});
  background-size: contain;
  background-repeat: no-repeat;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    width: 768px;
    height: 99px;
    background-image: url(${pageAd2x});
  }
`;

const AdWrap = styled.a`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[3]};
`;

const PageAd = () => {
  return (
    <AdWrap
      href="https://wlbetclicpt.adsrv.eacdn.com/C.ashx?btag=a_3158b_62c_&affid=1203"
      aria-label="Betclic advertisement"
      target="_blank"
      rel="noopener noreferrer"
    >
      <StyledImage />
    </AdWrap>
  );
};

export default PageAd;
